import { formatNum } from 'admin/utils';
import React from 'react';
import styles from './styles.scss';

const ClearingCell = ({ amount }) => {
  return (
    <div className={styles['amount-box']}>
      <span className={amount < 0 ? styles['negative-amount'] : styles['positive-amount']}>
        {formatNum(Math.abs(amount))}
      </span>
      <span>&nbsp; 円</span>
    </div>
  );
};

export default ClearingCell;
